export default __webpack_public_path__ + "static/ga-0e403b5cf69a19856c0a11f3533d254c.png";